import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import DayPicker from 'react-day-picker'
import Button from 'components/Button'
import { Transition } from '@headlessui/react'

const DatePickerPopover = ({
  isOpen,
  modifiers = [],
  onDayClick = () => { },
  disabledDays = [],
  clearDates = () => { },
  confirmDates = () => { },
  currentDate,
  variant = 'form',
}) => {
  return (
    <Transition
      as={Fragment}
      show={isOpen}
      enter="transition-opacity duration-75"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-75"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className={`absolute z-10 shadow-public-searchbar bg-white date:w-screen lg:h-[inherit] xs:min-w-[370px] ${variant === 'form'
        ? 'mx-[-35px] xs:mx-0 inset-x-0 date:-right-100 date:left-auto 3xl:!-inset-x-1/2 lg:max-w-[750px]'
        : 'right-0 max-w-[370px] date:max-w-[750px]'}
      `}>
        <div className="pt-40 mx-auto pb-30 sm:px-20 h-min">
          <DayPicker
            initialMonth={currentDate}
            className="flex justify-center focus DayPickerPublic DayPicker-custom-inline"
            numberOfMonths={2}
            modifiers={modifiers}
            onDayClick={onDayClick}
            disabledDays={disabledDays}
            weekdaysShort={['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']}
          />
          <div className="flex flex-wrap sm:flex-nowrap justify-center lg:justify-between px-20 mt-20 sm:px-0 gap-20">
            <Button
              variant="secondary"
              className="whitespace-nowrap text-12 rounded-full h-[34px]"
              onClick={() => clearDates()}
            >
              clear dates
            </Button>
            <Button
              className="whitespace-nowrap uppercase text-12 rounded-full h-[34px]"
              onClick={() => confirmDates()}
            >
              confirm dates
            </Button>
          </div>
        </div>
      </div>
    </Transition>
  )
}

DatePickerPopover.propTypes = {
  isOpen: PropTypes.bool,
  modifiers: PropTypes.array,
  onDayClick: PropTypes.func,
  disabledDays: PropTypes.array,
  clearDates: PropTypes.func,
  confirmDates: PropTypes.func,
  currentDate: PropTypes.any,
  variant: PropTypes.oneOf(['form', 'modal']),
}

export default DatePickerPopover
